import { render, staticRenderFns } from "./OptionItem.vue?vue&type=template&id=777a0112&scoped=true"
import script from "./OptionItem.vue?vue&type=script&lang=js"
export * from "./OptionItem.vue?vue&type=script&lang=js"
import style0 from "./OptionItem.vue?vue&type=style&index=0&id=777a0112&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777a0112",
  null
  
)

export default component.exports